"use client";

import { motion } from "framer-motion";
import { Globe, Phone, BarChart3, CreditCard, Users } from "lucide-react";

const capabilities = [
  { icon: Globe, label: "Multilingual Support" },
  { icon: Phone, label: "Automated Dialing" },
  { icon: BarChart3, label: "Reporting & Exports" },
  { icon: CreditCard, label: "Stripe Subscriptions" },

  { icon: Users, label: "Human Project Support" },
];

export default function TrustStrip() {
  return (
    <section
      style={{
        background: "var(--color-bg-alt)",
        padding: "56px 24px",
      }}
    >
      <div className="section-inner">
        <p
          style={{
            textAlign: "center",
            fontFamily: "var(--font-body)",
            fontSize: "0.92rem",
            fontWeight: 400,
            color: "var(--color-text-muted)",
            marginBottom: 40,
            letterSpacing: "0.01em",
          }}
        >
          Trusted by market research firms and call center teams across the globe.
        </p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
            gap: 32,
            maxWidth: 900,
            margin: "0 auto",
          }}
        >
          {capabilities.map((cap, i) => (
            <motion.div
              key={cap.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 12,
              }}
            >
              <div
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: 14,
                  background: "var(--color-bg)",
                  border: "1px solid var(--color-border)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                }}
              >
                <cap.icon size={22} color="var(--color-text)" strokeWidth={1.6} />
              </div>
              <span
                style={{
                  fontFamily: "var(--font-body)",
                  fontSize: "0.82rem",
                  fontWeight: 500,
                  color: "var(--color-text)",
                  textAlign: "center",
                }}
              >
                {cap.label}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
